declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void
    }
}

const GTAG_PARAM = 'gtag'

const findAnchor = (target: EventTarget | null): HTMLAnchorElement | null => {
    if (!(target instanceof Element)) return null
    return target.closest('a')
}

const getGtagEventName = (anchor: HTMLAnchorElement): string | null => {
    const href = anchor.getAttribute('href')
    if (!href) return null

    let url: URL
    try {
        url = new URL(href, window.location.href)
    } catch {
        return null
    }

    const value = url.searchParams.get(GTAG_PARAM)?.trim()
    return value ? value : null
}

const emitEvent = (eventName: string) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName)
        return
    }

    if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName })
        return
    }

    console.warn(`[gtag-link-handler] gtag/dataLayer not loaded; cannot emit "${eventName}"`)
}

const handleClick = (e: MouseEvent) => {
    const anchor = findAnchor(e.target)
    if (!anchor) return

    const eventName = getGtagEventName(anchor)
    if (!eventName) return

    emitEvent(eventName)
}

export const initGtagLinkHandler = () => {
    // Capture phase so this runs before swup or any other click consumer.
    document.addEventListener('click', handleClick, { capture: true })
    document.addEventListener('auxclick', handleClick, { capture: true })
}

export {}
